module.exports = __webpack_public_path__ + "img/sld_acdb_mfm_lt_panel_t1_b1.5027322e.svg";